import React, { FC } from "react";

/**
 * The handful of Material glyphs the form fields draw, inlined so the fields do not pull in
 * @mui/icons-material (and SvgIcon, and emotion) for six paths. Same 24x24 artwork as the
 * Material icons they replace, and decorative: the control they sit in carries the name.
 */
interface FieldIconProps {
    readonly className?: string;
}

const icon = (path: string): FC<FieldIconProps> => {
    const FieldIcon: FC<FieldIconProps> = ({ className }) => (
        <svg
            className={className}
            viewBox="0 0 24 24"
            width="1em"
            height="1em"
            fill="currentColor"
            aria-hidden="true"
            focusable="false">
            <path d={path} />
        </svg>
    );
    return FieldIcon;
};

export const CheckIcon = icon("M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z");

export const CheckBoxIcon = icon(
    "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
);

export const CheckBoxOutlineIcon = icon(
    "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
);

export const RadioCheckedIcon = icon(
    "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
);

export const RadioUncheckedIcon = icon(
    "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
);

export const ArrowDropDownIcon = icon("M7 10l5 5 5-5z");
